export default "__VITE_ASSET__Nhr4sWT0__"